<template>
  <div class="kr-layout-content">
    <!--内容同步-->
    <div class="publish graphicManage">
      <div class="publish-top">
        <ul class="per-list">
          <li>内容同步</li>
        </ul>
        <ul class="total">
          <li>
            今日发布数量：
            <span>0</span> / 6
          </li>
          <li>发文规范</li>
        </ul>
      </div>
      <div class="sync">
        <div class="btn-list active" @click="tkShow">新建同步</div>
        <div class="table-container">
          <table class="table text-center">
            <tr class="table-title" style="height:44px;">
              <th>同步连接</th>
              <th>同步类型</th>
              <th>创建时间</th>
              <th>状态</th>
              <th>操作</th>
            </tr>
            <tr v-for="(item,index) in myData" :key="index">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                <span @click="del(index)">删除</span>
              </td>
            </tr>
          </table>
          <p v-if="myData.length==0" class="text-center">暂无数据</p>
        </div>
      </div>

      <!-- 新建同步弹框 -->
      <div v-if="newShow" class="mask" @click.stop="tkClose"></div>
      <div v-if="newShow" class="new-build">
        <div class="top">
          新建同步
          <i class="iconfont icon-quxiao" @click.stop="tkClose"></i>
        </div>
        <div class="choice-type">
          <p>请选择同步连接的类型</p>
          <div class="sync-type" @click.stop="typeSlide">
            <span v-text="typeName"></span>
            <i class="iconfont icon-shangla11"></i>
          </div>
          <ul v-if="typeShow" class="sync-list">
            <li v-for="(item,index) in typeList" :key="index" @click.stop="name(item.title)">{{item.title}}</li>
          </ul>
        </div>
        <div class="sycn-link">
          <p class="oneline">
            请输入同步连接(
            <span>点击查看微信同步方式</span>)
          </p>
          <input type="text" placeholder="请你务必确保对提交的内容源拥有版权" />
        </div>
        <div class="upload-img">
          <p>同步内容源后台截图</p>
          <div class="upload-fails">
            <div class="upload-btn">上传图片</div>
            <div class="remind">
              <p>请提供其平台的后台截图，需体现出账号名称及后台地址</p>
              <p>支持jpg、jpeg、png格式,大小不超过5M</p>
            </div>
          </div>
        </div>
        <ul class="submit-btn">
          <li class="cancel active">确定</li>
          <li class="sure">取消</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
export default {
  // name: "App",
  data() {
    return {
      myData: [],
      typeShow: false,
      newShow:false,
      typeName:'微信',
      typeList:[
        {
          title:'微信'
        },
        {
          title:'支付宝'
        }
      ]
    };
  },
  mounted() {},
  methods: {
    add() {
      this.myData.push(1);
    },
    del(index) {
      this.myData.splice(index, 1);
    },
    typeSlide() {
      this.typeShow = !this.typeShow;
      // const fn = () => {
      //   this.typeShow = !this.typeShow;
      //   document.removeEventListener("click", fn);
      // };
      // document.addEventListener("click", fn, false);
    },
    tkShow(){
      this.newShow = true;
    },
    tkClose(){
      this.newShow = false;
    },
    name(name){
      this.typeShow = !this.typeShow;
      this.typeName = name
    }
  }
};
</script>

<style scoped>
.publish .publish-top {
  border: none;
}
.publish .publish-top .per-list li::after {
  height: 0px;
}
.publish .btn-list.active {
  cursor: pointer;
}
.table-container {
  margin-top: 65px;
}
.table tr {
  height: 64px;
}
.table-title {
  font-weight: bold;
  font-size: 16px;
  background: #f4f4f4;
}
.table th,
.table td {
  border: none;
}
.table td {
  padding: 0px;
}
.table tr:hover {
  background: #ccc;
}
.table tr.table-title {
  background: #f4f4f4;
}
.table th:first-child {
  width: 30%;
}
.table th:nth-child(2) {
  width: 12%;
}
.table th:nth-child(3) {
  width: 30%;
}
.table th:nth-child(4) {
  width: 16%;
}
.table th:nth-child(5) {
  width: 12%;
}
.table td span {
  display: block;
  width: 60px;
  padding: 0px 5px;
  margin: 20px auto;
  order: none;
  background: none;
  cursor: pointer;
  color: #419aff;
}
</style>